import React from "react";
import { useParams } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BcrumbBannerOne from "../elements/breadcrumb/BcrumbBannerOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ProjectPropOne from "../component/project/itemProp/ProjectPropOne";
import { slugify } from "../utils";
import ServiceData from "../data/service/ServiceMain.json";
import ProjectData from "../data/project/ProjectData.json";
import AboutTwo from "../component/about/AboutTwo";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import Tilty from "react-tilty";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientOne from "../component/client/ClientOne";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";
import ClientSlider from "../component/client/ClientSlider";
import CounterUpOne from "../component/counterup/CounterUpOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";

const allServiceData = ServiceData;
const getProjectData = ProjectData;

const OurStory = () => {
  // const params = useParams();
  // const serviceSlug = params.slug;

  // const getServiceData = allServiceData.filter(data => slugify(data.title) === serviceSlug);
  const detailsService = ServiceData[0];

  return (
    <>
      <SEO title="Service Details" />
      {/* <ColorSwitcher /> */}
      <main className="main-wrapper">
        <HeaderOne />
        {/* <BcrumbBannerTwo
          title="Who We Are"
          paragraph=""
          styleClass=""
          noimg={true}
          mainThumb="/images/banner/aboutus.jpg"
          // mainThumb="/images/banner/industry-img.jpg"
        /> */}
        <BreadCrumbOne
          subtitle="Our story, Our Values"
          title="Who We Are"
          page="Who-we-are"
        />
        <div className="container " style={{maxWidth: "800px" ,paddingTop:'70px', paddingBottom:'40px' }}>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            UCWF: Delivering Excellence in Facilities Management for 19 Years
          </h5>
          <p>
            For over 19 years, UCWF has been a trusted leader in the UAE’s
            facilities management sector, providing comprehensive solutions
            tailored to diverse operational needs. Our commitment to transparent
            communication and collaboration ensures a deep understanding of our
            clients’ specific requirements, allowing us to deliver seamless,
            high-quality facility management services.
            Whether managing large-scale, complex operations or catering to
            smaller, specialized businesses, we offer end-to-end solutions
            designed to maintain facilities at optimal performance levels. Our
            specialized services enable clients to consolidate all their
            maintenance needs under one provider, enhancing efficiency and
            reducing costs. Through the seamless integration of budgeting,
            communication, and accountability, we provide clarity and peace of
            mind. Additionally, our 24/7 emergency response service guarantees
            that skilled engineers are always available to deliver prompt,
            reliable support.{" "}
          </p>
          <p>
            
          </p>
          {/* <p>Over the years, we have broadened our horizons through entrepreneurial growth, strategic alliances, and acquisitions. In addition to energy management, specialised cleaning, security services, and electrical system maintenance, we also service large-scale chillers. Our earning the title of Energy Services Company (ESCO) demonstrates our commitment to using cleaner energy sources.</p>
        <p>With many active projects, UCWF is now one of the best facilities management companies in the UAE. They work with infrastructure, luxury properties, mixed-use developments, retail, education, and other fields. We are experts in Energy Management, Predictive/Preventive Maintenance, Strategic Facilities Planning (SFP), and a wide range of different services, such as hospitality, cleaning, security, and specialised ones.</p>
        <p>We at UCWF support the UAE's goal of a smart and sustainable future by embracing new technologies and following the strictest international rules. Our goal is to give our clients the best service possible and ensure that their facilities are not only well-kept but also ready for the future. Our work together is creating long-lasting solutions that will help make tomorrow better for businesses and communities tomorrow. </p>
        <p>Quality and dependability meet at UCWF Facility Management Services. Starting out, we wanted to change the way facility management was done by coming up with new, customer-focused solutions. We are now a trusted partner to companies in a wide range of industries, thanks to our unmatched expertise and dedication to quality.  Facility Management Services that we provide are </p> */}
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            Driving Growth and Innovation in Facilities Management{" "}
          </h5>
          <p>
            UCWF’s expansion has been fuelled by entrepreneurial growth,
            strategic partnerships, and key acquisitions. Our expertise spans a
            wide range of essential services, including energy management,
            specialized cleaning, security, electrical system maintenance, and
            large-scale chiller servicing. As an accredited Energy Services
            Company (ESCO), we are committed to sustainability and the adoption
            of cleaner energy solutions. Today, UCWF is recognized as one of the
            leading facilities management providers in the UAE, delivering
            excellence across various sectors, including infrastructure, luxury
            properties, mixed-use developments, retail, education, and more. Our
            expertise extends to Energy Management, Predictive and Preventive
            Maintenance, Strategic Facilities Planning (SFP), as well as
            specialized services in hospitality, cleaning, and security.{" "}
          </p>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            Commitment to a Smarter, Sustainable Future{" "}
          </h5>
          <p>
            At UCWF, we align with the UAE’s vision for a smart and sustainable
            future by embracing cutting-edge technologies and adhering to the
            highest international standards. Our mission is to deliver
            exceptional service, ensuring that facilities are not only
            well-maintained but also future-ready. By fostering long-term
            partnerships, we create sustainable solutions that drive progress
            for businesses and communities alike.
          </p>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            UCWF Facility Management Services: Where Quality Meets Reliability{" "}
          </h5>
          <p>
            From the outset, our goal has been to revolutionize facilities
            management through innovative, client-centric solutions. Today, UCWF
            is a trusted partner across diverse industries, known for its
            unparalleled expertise and unwavering commitment to excellence.
          </p>
          {/* <h5 style={{ textAlign: "left", color:"#562b7a" }}>Security Services</h5>
          <p>
            UCWF has a team of fully qualified and trained guards who offer risk
            management, consulting, and security services. We take security
            steps that are both effective and cost-effective, from short-term
            cover to long-term solutions that are made to fit your needs. We do
            this by following a strict process.
          </p>
          <h5 style={{ textAlign: "left", color:"#562b7a" }}>Specialized Services</h5>
          <p>
            In UAE, UCWF offers specialised property management services such as
            pest control, waste management, and cleaning & disinfecting. Our
            skilled professionals keep the area clean, safe, and germ-free by
            performing regular upkeep and providing quick, high-quality service
            solutions.
          </p> */}
        </div>

        {/* <CounterUpTwo /> */}

        <CounterUpOne />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        {/* // In your page/component: */}
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />
        <AboutThree />
        {/* <CtaLayoutOne /> */}
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default OurStory;
